import { getExclusion } from 'ha/utils/exclusionDate';
import { WEEK_IN_MS } from 'ha/helpers/hadate';
import { TypesAlgolia, KindsAlgolia } from 'ha/constants/Room';
import { AlgoliaListing } from 'ha/services/apiV2/types/AlgoliaListing';

import { NormalizedListing } from '../Types';

interface NormalizeOptions {
  currency: string;
  currencyRate: number;
  imageApiVersion?: 'v1' | 'v2';
}

const normalizeListing = ({
  currency,
  currencyRate,
  imageApiVersion,
}: NormalizeOptions) => (item: AlgoliaListing): NormalizedListing => {
  let photos = item.photos || [];

  if (imageApiVersion === 'v2') {
    photos = photos.map(photo => {
      return photo.replace('.com/images', '.com/v2/images');
    });
  }

  return {
    ...item,

    // TODO: Refactor components so only one id is used
    id: item.internalID,
    entityId: item.internalID,
    kind: KindsAlgolia[item.kind],
    type: TypesAlgolia[item.type],
    advertiser: { avatarURL: item.advertiserAvatar },
    currency,
    listingPath: item.path,
    previewImage: item.thumbnailURL,
    price: currencyRate * item.priceEUR * 100,
    isNew: Date.now() - item.creationDateTS * 1000 < WEEK_IN_MS,
    minimalRentalPeriod: item.minimumStayMonths,
    exclusions: [getExclusion(item.dateFrom, item.dateTo)],

    latitude: (item._geoloc && item._geoloc.lat) || null,
    longitude: (item._geoloc && item._geoloc.lng) || null,

    photos,
  };
};

export default normalizeListing;
